import React from 'react';

interface Player {
  id: string;
  name: string;
  score?: number;
  avatar?: string;
  isBot?: boolean;
}

interface PlayersListProps {
  players: Player[];
  variant?: 'compact' | 'detailed' | 'grid';
  showScores?: boolean;
  className?: string;
  style?: React.CSSProperties;
  renderPlayerActions?: (player: Player) => React.ReactNode;
}

export const PlayersList: React.FC<PlayersListProps> = ({
  players = [],
  variant = 'compact',
  showScores = false,
  className,
  style,
  renderPlayerActions,
}) => {
  if (players.length === 0) {
    return null;
  }

  return (
    <div
      className={`players-container players-container--${variant} ${className || ''}`.trim()}
      style={style}
    >
      {players.map((player) => (
        <div key={player.id} className="player-item">
          {player.avatar &&
          (player.avatar.startsWith('/') ||
            player.avatar.startsWith('data:') ||
            player.avatar.includes('.svg')) ? (
            <img className="player-item__avatar-img" src={player.avatar} alt="" />
          ) : (
            <span className="player-item__avatar-emoji">{player.avatar || '👤'}</span>
          )}
          <span className="player-item__name">{player.name}</span>
          {showScores && player.score !== undefined && (
            <span className="player-item__score">{player.score}</span>
          )}
          {renderPlayerActions && (
            <span className="player-item__actions">{renderPlayerActions(player)}</span>
          )}
        </div>
      ))}
    </div>
  );
};
